<template>
  <div class="sunnyfactoryWrap">
    <div class="sunnyfactoryWrapInner">

      <div class="headWrap">
      </div>

      <div class="sunnyfactoryCommentWrap">
        <h1 class="title">SUNNY FACTORY</h1>
        <h4 class="subTitle">창의적인 UI, 그리고 컨텐츠</h4>
        <p>
          언제 어디서나, 모든 기기에 똑같은 화면과 기능이 구현되는<br/>
          써니 팩토리만의 다양한 컨텐츠로 다가갑니다.
          <br/><br/>
          다양한 프로그램 개발 경험과 창의적 구성, 편의성을 기반으로<br/>
          고객의 Needs를 정확하게 이해, 파악하고 설계에서 개발, 테스트까지 책임지고 완료<br/>
          운영과 차후 보완까지 최선을 다합니다.
        </p>
        <span class="sfCircleLogo">
        </span>
      </div>

      <history/>

      <issue/>

      <information v-if="about !== undefined"/>

      <location v-if="location !== undefined"/>




    </div>
  </div>
</template>
<script>
    import History from '@/components/menu/Sunnyfactory/History'
    import Information from '@/components/menu/Sunnyfactory/Information'
    import Issue from '@/components/menu/Sunnyfactory/Issue'
    import Location from '@/components/menu/Sunnyfactory/Location'
    import { mapGetters } from 'vuex'

    export default {
        name: "SunnyFactory",
        components : {
          'history' : History,
          'information' : Information,
          'issue' : Issue,
          'location' : Location,
        },
        computed : {
          ...mapGetters({
            about: 'informationStore/getInformationAbout',
            location : 'informationStore/getInformationLocation'
          })
        },
        created () {
          this.$store.dispatch('informationStore/getInformation');
          //console.log('SUNNY FACTORY CREATED!!');
        },
        mounted () {

        },
        methods : {

        }

    }
</script>

<style scoped lang="scss">
  @import "@/styles/Sunnyfactory.scss";

</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory.vue